<template>
  <div class="product-com" @click.stop="goProductDetail">
    <div class="product-top">
      <div class="product-top-info flex p-14">
        <img class="w-60 h-60"
          :preview="false"
          style="border-radius: 4px"
          :src="product.absoluteThumbnailUrl"
        />
        <div class="product-info ml-8">
          <div class="product-name text-base font-bold text-left">
            {{product.productName}}
          </div>
          <div class="product-price flex items-center" v-if="product?.productSupplyPriceListDtos.length==1">
            <div class="memberrship-price-tip">最低价</div>
            <div class="ml-4 mr-4 memberrship-price">¥{{utils.toFixed2(product.actualPrice)}}</div>
            /{{product.unitName}}{{product.priceType=='LADDER'?'起':''}}
          </div>
          <div class="product-price flex items-center" v-else>
            <div class="memberrship-price-tip">最低价</div>
            <div class="ml-4 mr-4 memberrship-price">¥{{setMinPrice(product.productSupplyPriceListDtos)}}</div>
            /{{product.unitName}}{{product.priceType=='LADDER'?'起':''}}
          </div>
        </div>
      </div>
      <!-- <div
        class="product-view-price mb-14 ml-14 flex justify-between items-center"
      >
        <span>点击查看报价</span><RightOutlined />
      </div> -->
      <!--  v-if="product?.productSupplyPriceListDtos.length>1" -->
      <div class="product-buy-btn mb-14 ml-14 align-center" @click.stop="showModal(product)">点击查看报价</div>
    </div>
    <div class="product-btm flex items-center" @click.stop="goProductStore">
      <img src="@/assets/home/store-icon.png" class="supplier-img mr-6" />
      <span>{{product.supplierName}}</span>
    </div>
  </div>
  <!-- 弹窗查看报价 -->
  <a-modal v-model:open="open" title="全部报价">
    <template #footer>
        <div class="flex justify-center modal-btn-box">
            <a-button class="modal-cancel-btn" key="back" @click="open=false">取消</a-button>
            <a-button class="modal-submit-btn" key="submit" type="primary" @click="handleOk">确定</a-button>
        </div>
    </template>
    <a-table
        class="ant-table-striped"
        size="middle"
        :scroll="{ y: 240 }"
        :pagination="false"
        :columns="columns"
        :data-source="data"
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" >
        <template #bodyCell="{ column, text, record }">
          <template v-if="column.dataIndex === 'actualPrice'">
            <span>{{ utils.toFixed2(text) }}</span>
          </template>
          <template v-if="column.dataIndex === 'operation'">
            <a-button type="link" @click.stop="openManagerPage">修改价格</a-button>
          </template>
        </template>
      </a-table>
    </a-modal>
</template>
<script setup>
import { ref, computed } from "vue";
import { RightOutlined } from "@ant-design/icons-vue";
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { message } from "ant-design-vue";
import api from '@/net/api'
const store = useStore()
const Token = computed(() => store.state.token?.token || '')
import utils from "@/utils";
const router = useRouter()
const props = defineProps({
  product: {
    required: true, // 是否必传
    type: Object,
    default: () => {}
  },
  style:{
    required: false, // 是否必传
    type: Object,
    default: () => {}
  }
})
// const props = defineProps(['recentList'])
const columns = [
  {
    title: '餐厅名称',
    align: 'center',
    dataIndex: 'restaurantName',
  },
  {
    title: '报价',
    align: 'center',
    dataIndex: 'actualPrice',
  },
  {
    title: '操作',
    align: 'center',
    dataIndex: 'operation',
  },
];
const data = ref([
  
]);
const open = ref(false);
const showModal = (product) => {
  open.value = true;
  data.value = product.productSupplyPriceListDtos
};
const handleOk = e => {
  console.log(e);
  open.value = false;
};
function setMinPrice(data){
  let priceList = []
  data.forEach(element => {
    priceList.push(element.actualPrice)
  });
  let pricrMin = Math.min(...priceList)
  console.log('11111111111',pricrMin)
  return utils.toFixed2(pricrMin)
}

// 跳转管理后台
function openManagerPage() {
  let url = ''
  switch (process.env.NODE_ENV) {
    case 'development':
      url = 'https://test.rongdaufun.com/'
      break
    case 'production':
      url = 'https://www.rongdajicai.com/'
      if (location.host == 'test.rongdaufun.com') {
        url = 'https://test.rongdaufun.com/'
      }
      break
    default:
      break
  }
  // window.open(url)
  // 创建一个iframe
  const iframe = document.createElement('iframe')
  iframe.style.height = '0'
  iframe.style.border = 'none'
  // 先跳转到 switch-region.html 中转页，将 token 等信息带到新域名
  iframe.src = url+`spa/switch-region.html?Token=`+Token.value

  document.body.appendChild(iframe)

  // iframe加载，表示token已经写入到新域名中
  // 跳转到 ng 站点
  iframe.onload = () => {
    let timer = setTimeout(() => {
      // window.location.href = 'https://www.rongdajicai.com/sc-manager/#/main/product/orgProduct'
      window.open('https://www.rongdajicai.com/sc-manager/#/main/product/orgProduct')
      clearTimeout(timer)
    }, 1000)
  }

}
// 商品详情
function goProductDetail(){
  console.log(props.product)
  if((props.product.id||props.product.productId) && props.product.supplierId){
    router.push('/main/productInfo?id='+(props.product.id||props.product.productId)+'&storeId='+props.product.supplierId)
  }else{
    message.warning('跳转失败，请重试')
  }
}
// 去店铺
function goProductStore(){
  if(props.product.supplierId){
    router.push('/main/store/detail?id='+props.product.supplierId)
  }else{
    message.warning('跳转失败，请重试')
  }
}
</script>
<style lang="scss" scoped>
@import "./style/recentBuyProductCom.scss";
[data-doc-theme='light'] .ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}
[data-doc-theme='dark'] .ant-table-striped :deep(.table-striped) td {
  background-color: rgb(29, 29, 29);
}
</style>
